import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import Button from 'components/Button';
import isEmpty from 'lodash/isEmpty';
import InputMask from 'react-input-mask';
import './RequestForm.scss';
import Tooltip from '@material-ui/core/Tooltip';
import Alert from 'components/Alert';
import Modal from 'react-modal';
import { TermsField } from 'components/TermsField';
import CustomFields from 'components/CustomFields';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        background: 'none',
        boxShadow: 'none',
        zIndex: '999',
        backgroundColor: "rgba(255, 255, 255)"
    }
};

const useValidator = (validator = value => !!value, initialValue) => {
    const [state, setstate] = useState(initialValue)
    const [error, setError] = useState(false)
    const setStateWithValidation = (value) => {
        setstate(value);
        const error = validator(value)
        setError(error)
    }
    return [state, error, setStateWithValidation]
}

const ValidateEmail = email => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !re.test(String(email).toLowerCase());
}

const ValidateName = name => !name || name.length < 3

const ValidatePhone = phone => !phone || phone.length !== 12

const RequestForm = (props) => {
    const [name, nameError, setName] = useValidator(ValidateName)
    const [email, emailError, setEmail] = useValidator(ValidateEmail)
    const [phone, phoneError, setPhone] = useValidator(ValidatePhone)
    const [modalCancelRules, setModalCancelRules] = useState(false)
    const [termsChecked, setTermsChecked] = useState(false)
    const [observation, setObservation] = useState("")

    // Checa se um dos campos nao foi informado
    const blockContinue = !(props.isDateSelected && props.isHourSelected) || // Data nao selecionada
        nameError || emailError || phoneError || // Campos minimos
        isEmpty(name) || isEmpty(email) || isEmpty(phone) || // Campos minimos
        props.fields.reduce((isEmpty, field) => isEmpty || !field.value || (!!field.validator && field.validator(field.value)), false) || // Campos personalizados
        (props.showTerms && !termsChecked) || // Aceite de termos
        !props.privacyChecked // Aceite de privacidade

    return (
        <div className="request-form-container">
            {props.isDateSelected && props.isHourSelected &&
                <div>
                    <p className="label label-green">
                        <span className="icon-checkmark-circle" />
                        Horário disponivel para agendamento
                        <Tooltip title="Este é um horário exclusivo. Ao agendar, este horário não ficará disponível para outras pessoas, somente seus convidados.">
                            <span className="tooltip-helper">?</span>
                        </Tooltip>
                    </p>
                    <div className="Grid Gird-cell">
                        <h3 className="side-checkout-title">Insira seus dados</h3>
                    </div>
                    <p className="side-checkout-text">Você não precisa pagar para agendar um horário</p>
                    <div className="Grid Grid-cell input-cell">
                        <div className="Grid-cell">
                            <div className="full-width group-input">
                                <input
                                    className="full-width"
                                    placeholder="Nome completo"
                                    type="name"
                                    required
                                    name="name"
                                    autoComplete="off"
                                    onChange={(e) => setName(e.target.value)}
                                    value={name}
                                />
                                {/* <span className="help-hasError">{(billingAttributes.districtError === true ? ' "Bairro" não pode ficar em branco.' : '')}</span> */}
                            </div>
                        </div>
                    </div>
                    <div>
                        <Alert formError={nameError ? { status: true, message: "Nome é um campo obrigatório" } : {}} />
                    </div>
                    <div className="Grid Grid-cell input-cell">
                        <div className="Grid-cell">
                            <div className="full-width group-input">
                                <input
                                    className="full-width"
                                    placeholder="Email"
                                    type="email"
                                    required
                                    name="email"
                                    autoComplete="off"
                                    onChange={(e) => setEmail(e.target.value)}
                                    value={email}
                                />
                                {/* <span className="help-hasError">{(billingAttributes.districtError === true ? ' "Bairro" não pode ficar em branco.' : '')}</span> */}
                            </div>
                        </div>
                    </div>
                    <div>
                        <Alert formError={emailError ? { status: true, message: "Email inválido" } : {}} />
                    </div>
                    <div className="Grid Grid-cell input-cell">
                        <div className="Grid-cell">
                            <div className="full-width group-input">
                                <InputMask
                                    mask="99 999999999"
                                    className="full-width"
                                    placeholder="Telefone Celular"
                                    type="text"
                                    required
                                    name="phone"
                                    maskChar={null}
                                    onChange={(e) => setPhone(e.target.value)}
                                    value={phone} />
                                {/* <span className="help-hasError">{(billingAttributes.districtError === true ? ' "Bairro" não pode ficar em branco.' : '')}</span> */}
                            </div>
                        </div>
                    </div>
                    <div>
                        <Alert formError={phoneError ? { status: true, message: "Número inválido" } : {}} />
                    </div>
                    <CustomFields fields={props.fields} onChange={props.onChange} showLabel={false}>
                        {
                            (fields) => fields.map((field) => (
                                <React.Fragment>
                                    <div className="Grid Grid-cell input-cell">
                                        <div className="Grid-cell">
                                            <div className="full-width group-input">
                                                {field}
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))
                        }
                    </CustomFields>
                    {
                        props.request_observation_enabled &&
                        <div className="Grid Grid-cell input-cell">
                            <div className="Grid-cell">
                                <div className="full-width group-input">
                                    <textarea
                                        placeholder="Observação (Ex: Atendimento especial, código promocional, etc.)"
                                        name="observation"
                                        className="full-width"
                                        value={observation}
                                        onChange={(e) => setObservation(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    <TermsField
                        checked={termsChecked}
                        onChange={setTermsChecked}
                        terms={props.terms}
                        show={props.showTerms}
                    />
                    <div className="full-width group-input">
                        <input
                            style={{ display: "inline-block" }}
                            type="checkbox"
                            checked={props.privacyChecked}
                            onChange={props.onPrivacyToggle}
                        />
                        <div className="concordo" > Concordo com a </div>
                        <a className="link" href={props.privacyTerm} target="_blank" rel="noopener noreferrer">Política de privacidade de dados</a>
                    </div>
                </div>
            }
            <div className="Grid Grid--center contract contract-mobile">
                <Button
                    loading={props.requestLoading}
                    disabled={blockContinue} type="green" size="full"
                    onClick={() => props.submitRequest({ name, email, phone, observation })}
                >
                    {(props.requestLoading ? <p><i className='fa fa-spinner fa-spin'></i></p> : <p>RESERVAR</p>)}
                </Button>
            </div>
            {!props.noLinks &&
                <>
                    <div className="Grid-row text-pink" style={{ marginTop: 10, alignItems: 'center' }} >
                        <i style={{ marginRight: 10, fontSize: 28 }} className="fa fa-info-circle text-pink" />
                        <div className="Grid-cell">
                            <small>Alguma informação contida aqui você não está de acordo? <a className="text-pink" rel="noopener noreferrer" target="_blank" href="https://api.whatsapp.com/send?phone=5541997788987">Informe um problema</a></small>
                        </div>
                    </div>
                    <div className="Grid-row">
                        <div className="Grid-cell">
                            <Link onClick={() => props.cancel_rules ? setModalCancelRules(true) : window.open('/cancelamento', '_blank')}>
                                <p className="side-checkout-link">
                                    <span className="icon-book" />
                                    Cancelamento Fácil
                                </p>
                            </Link>
                        </div>
                        <div className="Grid-cell">
                            <Link to="/seguranca" target="_blank">
                                <p className="side-checkout-link">
                                    <span className="icon-lock" />
                                    Segurança de dados
                                </p>
                            </Link>
                        </div>
                        {props.cancel_rules &&
                            <Modal
                                isOpen={modalCancelRules}
                                onRequestClose={() => setModalCancelRules(false)}
                                style={customStyles}
                            >
                                <div className="box-modal">
                                    <div className="Grid Grid--gutter Grid-column">
                                        <div className="Grid-cell">
                                            <div className="close-modal">
                                                <p className="float-right" onClick={() => setModalCancelRules(false)}>
                                                    Fechar X
                                                </p>
                                            </div>
                                        </div>
                                        <div className="Grid-cell">
                                            <div className="modal-content content-cancel-rules">
                                                <h4>Regras de Cancelamento</h4>
                                                <div className='text'>
                                                    {props.cancel_rules}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        }
                    </div>
                </>
            }
        </div>
    )
}

export default RequestForm
